import React from 'react';
import { Typography, TextareaAutosize, TextField, Button, Box } from '@mui/material';

// Función para obtener el texto del estado
const getEstadoText = (estado: number) => {
  switch (estado) {
    case 1:
      return 'Activo';
    case 2:
      return 'Finalizado';
    case 3:
      return 'Liquidado';
    case 4:
      return 'Cancelado';
    default:
      return 'Desconocido';
  }
};

const ViewLiquidacion = React.memo(({ servicios, onClose }: any) => {
  return (
    <div>
      <form>
        <TextField label="Servicio" value={servicios.SrvDI_Id} fullWidth disabled sx={{ marginBottom: '0.8rem', marginTop: '1rem' }} size="small" />
        <TextField label="Empleado" value={`${servicios.In_Nombre}`} fullWidth disabled sx={{ marginBottom: '0.8rem', marginTop: '1rem' }} size="small" />
        <TextField label="Fecha de servicio" value={servicios.Srv_FechaServicio} fullWidth disabled sx={{ marginBottom: '0.8rem', marginTop: '1rem' }} size="small" />
        <TextField label="Fecha de registro" value={servicios.Srv_FechaRegistro} fullWidth disabled sx={{ marginBottom: '0.8rem', marginTop: '1rem' }} size="small" />
        <TextField label="Estado" value={getEstadoText(servicios.SrvDI_Estado)} fullWidth disabled sx={{ marginBottom: '0.8rem' }} size="small" />
        <TextField label="Valor" value={servicios.SrvDI_Valor} fullWidth disabled sx={{ marginBottom: '0.8rem' }} size="small" />
        <Box sx={{ marginBottom: '0.8rem', marginTop: '1rem', width: '100%' }}>
      </Box>
        <Box display="flex" justifyContent="flex-end">
          <Button onClick={onClose} variant="outlined" color="error" size="small">
            Cerrar
          </Button>
        </Box>
      </form>
    </div>
  );
});

export default ViewLiquidacion;
